var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.tasks > 0)?_c('span',{staticClass:"text-primary"},[_vm._v(" "+_vm._s(_vm.tasks)+" open tasks ")]):_vm._e(),(_vm.tasks === 0)?_c('span',[_vm._v(" No tasks ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }